export const InsuranceIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.69727 0.252776C8.59965 -0.0842587 10.0788 -0.0842587 11.0029 0.252776L16.4277 2.28598C17.678 2.75352 18.7002 4.23195 18.7002 5.56918V13.6473C18.7001 14.93 17.8519 16.6146 16.8193 17.3866C14.8324 18.8699 10.4389 21.9998 9.33887 21.9998C8.23866 21.9996 3.86224 18.8657 1.88086 17.3866C0.84819 16.6146 0.000130892 14.9301 0 13.6473V5.56918C0 4.24279 1.02217 2.76422 2.27246 2.29672L7.69727 0.252776ZM14.3281 5.29965C13.4231 5.30995 11.2678 5.49385 9.96094 7.06528C9.33311 7.81762 8.9997 8.77522 8.82422 9.66879C8.72807 9.57108 8.62649 9.47484 8.51465 9.38559L8.51562 9.38461C7.83755 8.84237 6.98414 8.57599 6.23926 8.44125C5.48491 8.30487 4.77316 8.29152 4.32227 8.30258C3.98741 8.31108 3.71277 8.55396 3.65234 8.87094L3.63965 9.01059C3.64831 9.74493 3.80269 11.5333 5.16406 12.62C6.19972 13.4496 7.67586 13.6471 8.63965 13.6903V15.9998C8.63966 16.3864 8.95334 16.6999 9.33984 16.7C9.72644 16.7 10.04 16.3864 10.04 15.9998V12.66C11.0966 12.555 12.6728 12.1842 13.7129 10.9325C14.3691 10.1445 14.6982 9.14585 14.8652 8.25961C15.0339 7.36456 15.0498 6.51921 15.0361 5.98227C15.0276 5.64735 14.7848 5.37266 14.4678 5.31235L14.3281 5.29965Z"
        fill="currentColor"
      />
    </svg>
  );
};
